import { type IconProps } from '../iconProps';

export const Roadmap: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V10C0 9.71667 0.0958333 9.47917 0.2875 9.2875C0.479167 9.09583 0.716667 9 1 9C1.28333 9 1.52083 9.09583 1.7125 9.2875C1.90417 9.47917 2 9.71667 2 10V16H10C10.2833 16 10.5208 16.0958 10.7125 16.2875C10.9042 16.4792 11 16.7167 11 17C11 17.2833 10.9042 17.5208 10.7125 17.7125C10.5208 17.9042 10.2833 18 10 18H2ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12V6C4 5.71667 4.09583 5.47917 4.2875 5.2875C4.47917 5.09583 4.71667 5 5 5C5.28333 5 5.52083 5.09583 5.7125 5.2875C5.90417 5.47917 6 5.71667 6 6V12H14C14.2833 12 14.5208 12.0958 14.7125 12.2875C14.9042 12.4792 15 12.7167 15 13C15 13.2833 14.9042 13.5208 14.7125 13.7125C14.5208 13.9042 14.2833 14 14 14H6ZM10 10C9.45 10 8.97917 9.80417 8.5875 9.4125C8.19583 9.02083 8 8.55 8 8V2C8 1.45 8.19583 0.979167 8.5875 0.5875C8.97917 0.195833 9.45 0 10 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V8C20 8.55 19.8042 9.02083 19.4125 9.4125C19.0208 9.80417 18.55 10 18 10H10ZM10 8H18V4H10V8Z'
        fill={fill}
      />
    </svg>
  );
};
